import React from "react";

function RoundedTag({
  title,
  textColor,
  bgColor,
  fontWeight,
  roundPercent,
  darkModeBorderColor,
  darkModeTextColor,
  darkModeBackgroundColor,
  onClick,
  borderColor,
}) {
  return (
    <p
      onClick={onClick}
      className={`w-full whitespace-nowrap flex items-center border text-${textColor} border-${borderColor} dark:text-${darkModeTextColor} dark:bg-${darkModeBackgroundColor} h-[34px] py-2 px-3 dark:border-${darkModeBorderColor} rounded-${roundPercent} justify-center font-${fontWeight} bg-${bgColor} cursor-pointer`}
    >
      {title}
    </p>
  );
}

export default RoundedTag;
